<!-- Both tab panels stay in the DOM so every route link is crawlable. -->
<section class="home-seo" aria-labelledby="home-seo-title">
  <div class="buupass-container">
    <div class="home-seo__head">
      <div class="home-seo__intro">
        <span class="home-seo__eyebrow"><app-icon name="takeoff" /> Flight routes</span>
        <h1 id="home-seo-title">Book cheap flights in Kenya and across Africa</h1>
        <p class="home-seo__lede">
          Compare Kenya Airways, Jambojet, Safarilink, Skyward Express, Airkenya and international airlines in one search.
          Pay with M-Pesa, Airtel Money or card and get your e-ticket instantly.
        </p>
      </div>
      @if (groups().length) {
        <div class="home-seo__tabs" role="tablist" aria-label="Flight route groups">
          @for (group of groups(); track group.title; let i = $index) {
            <button type="button" role="tab" class="home-seo__tab"
                    [id]="'route-tab-' + i"
                    [attr.aria-controls]="'route-panel-' + i"
                    [attr.aria-selected]="i === active()"
                    [class.is-active]="i === active()"
                    (click)="active.set(i)">
              {{ group.title }}
              <span class="home-seo__count">{{ group.routes.length }}</span>
            </button>
          }
        </div>
      }
    </div>

    @for (group of groups(); track group.title; let i = $index) {
      <div class="home-seo__grid" role="tabpanel"
           [id]="'route-panel-' + i"
           [attr.aria-labelledby]="'route-tab-' + i"
           [hidden]="i !== active()">
        @for (route of group.routes; track route.slug) {
          <app-route-card [route]="route" />
        }
      </div>
    }
  </div>
</section>
